const CONTAINER_SIDES_PADDING = 5;

const calculateCommentPercentPosition = (
container,
eventX,
eventY,
elementSize = 0) =>
{
  const { left, top, width, height } = container.getBoundingClientRect();
  const maxX = left + width - elementSize;
  const clickX = eventX - left - elementSize / 2;
  const fallBack = clickX < CONTAINER_SIDES_PADDING ? CONTAINER_SIDES_PADDING : clickX;

  const normalisedXClick = clickX > maxX ? maxX : fallBack;
  const clickY = eventY - top - elementSize / 2;
  const normalisedClickY = clickY < CONTAINER_SIDES_PADDING ? CONTAINER_SIDES_PADDING : clickY;
  const xPercent = (normalisedXClick / width * 100).toFixed(0);
  const yPercent = (normalisedClickY / height * 100).toFixed(0);

  return {
    x: xPercent,
    y: yPercent
  };
};

export default calculateCommentPercentPosition;